/*
 * Public API Surface of tournaments
 */

export * from './config';
export * from './routes';
